import { useBackendApi } from './backendApi';
import { useObjectDatesMapper } from './Helper';

export interface LlmConsent {
  optedIn: boolean;
  consentedAt?: Date;
  disclosureVersion?: string;
}

export const CURRENT_DISCLOSURE_VERSION = '1.0';

export const LLM_CONSENT_UPDATED = 'LLM_CONSENT_UPDATED';

function useLlmConsentMapper() {
  return useObjectDatesMapper<LlmConsent>([], ['consentedAt']);
}

export function useLlmConsentService() {
  const backendApi = useBackendApi();
  const mapper = useLlmConsentMapper();

  const getConsent = async (): Promise<LlmConsent> => {
    const response = await backendApi.get('/llm-chat/consent') as LlmConsent;
    return mapper.mapSingle(response);
  };

  const giveConsent = async (): Promise<LlmConsent> => {
    const response = await backendApi.post('/llm-chat/consent', {
      disclosureVersion: CURRENT_DISCLOSURE_VERSION,
    }) as LlmConsent;
    return mapper.mapSingle(response);
  };

  return {
    getConsent,
    giveConsent,
  };
}
